// Mobile Menu Button
var menu = document.querySelector('#menu');
var nav = document.querySelector('#navigation');

menu.onclick = function() {
    menu.classList.toggle('active');
    nav.classList.toggle('active');
};

document.querySelectorAll('.lazyload').forEach(image => {
    if (image.type === 'image/webp') {
        image.srcset = image.dataset.src;
        image.removeAttribute('data-src');
    } else {
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
    }

    image.classList.remove('lazyload')
});

const accordionLinks = document.querySelectorAll('.accordion h3');

for (var i = 0; i < accordionLinks.length; i++) {
    (accordionLinks[i]).addEventListener('click', function (e) {
        this.parentElement.classList.toggle('active');
    })
}

const pricingToggle = document.querySelector('button.toggle-switch');

if (pricingToggle) {
    pricingToggle.addEventListener('click', function (e) {
        let elements = this.parentElement.parentElement.children;
        for (var i = 0; i < elements.length; i++) {
            (elements[i]).classList.toggle('active');
        }
    })
}
